import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "jm-cart-v2";

export function CartProvider({ children }) {
    const [items, setItems] = useState([]);
    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        try { const raw = localStorage.getItem(KEY); if (raw) setItems(JSON.parse(raw)); } catch {}
        setHydrated(true);
    }, []);
    useEffect(() => { if (hydrated) localStorage.setItem(KEY, JSON.stringify(items)); }, [items, hydrated]);

    const lineId = (p, s, c) => `${p}__${s}__${c}`;

    const addItem = (product, size, color, quantity = 1) => {
        const id = lineId(product.id, size, color);
        setItems((prev) => {
            const found = prev.find((i) => i.lineId === id);
            if (found) return prev.map((i) => (i.lineId === id ? { ...i, quantity: i.quantity + quantity } : i));
            return [...prev, {
                lineId: id, productId: product.id, name: product.name, brand: product.brand || "",
                price: product.price, image: product.images?.[0] || "", size, color, quantity,
            }];
        });
    };
    const updateQty = (id, q) => setItems((p) => p.map((i) => (i.lineId === id ? { ...i, quantity: Math.max(1, q) } : i)));
    const removeItem = (id) => setItems((p) => p.filter((i) => i.lineId !== id));
    const clearCart = () => setItems([]);

    const totalItems = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
    const totalPrice = useMemo(() => items.reduce((s, i) => s + i.quantity * i.price, 0), [items]);

    return <CartCtx.Provider value={{ items, addItem, updateQty, removeItem, clearCart, totalItems, totalPrice }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
